// System
import { Box, Typography } from '@mui/material';

// Components
import { UserDrawerDetails } from './UserDrawerDetails';
import { TabDrawerLayout } from '@Components/shared/layouts/TabDrawerLayout';
import { DrawerHeaderLayout } from '@Components/shared/layouts/DrawerHeaderLayout';
import { SaveSettingsButtonPanel } from '@Components/shared/buttons/SaveSettingsButtonPanel';

// Redux
import { useDispatch } from 'react-redux';
import { useUserDrawer } from '@Modal/hooks/users/useUserDrawer';

export const SetupUserDrawerContent: React.FC = () => {
  const { selectedUser, setShowUserDrawer } = useUserDrawer();
  const dispatch = useDispatch();

  return (
    <TabDrawerLayout
      header={
        <DrawerHeaderLayout currentSlug="/users" onClose={() => dispatch(setShowUserDrawer(false))}>
          <Box>
            <Typography variant="h6">{selectedUser?.id}</Typography>
          </Box>
        </DrawerHeaderLayout>
      }
      footer={
        <SaveSettingsButtonPanel
          saveDisabled={true}
          onCancelClick={() => dispatch(setShowUserDrawer(false))}
        />
      }
    >
      <UserDrawerDetails />
    </TabDrawerLayout>
  );
};
